import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Trash } from "lucide-react";
import { Step } from "./types";

interface SequenceStepProps {
  step: Step;
  onRemove: () => void;
  onUpdate: (field: string, value: any) => void;
}

export const SequenceStep = ({ step, onRemove, onUpdate }: SequenceStepProps) => {
  return (
    <Card>
      <CardContent className="space-y-4 pt-4">
        <div className="flex justify-between items-center">
          <h4 className="font-medium">Step {step.step_number}</h4>
          <Button
            variant="ghost"
            size="sm"
            onClick={onRemove}
          >
            <Trash className="h-4 w-4" />
          </Button>
        </div>

        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <Switch
              id={`auto-trigger-${step.step_number}`}
              checked={step.auto_trigger}
              onCheckedChange={(checked) => onUpdate("auto_trigger", checked)}
            />
            <Label htmlFor={`auto-trigger-${step.step_number}`}>
              Auto-trigger for new leads
            </Label>
          </div>

          <Select
            value={step.subject_type}
            onValueChange={(value) => onUpdate("subject_type", value)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Subject Type" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="static">Static Subject</SelectItem>
              <SelectItem value="dynamic">Dynamic Subject</SelectItem>
            </SelectContent>
          </Select>

          <Input
            placeholder="Subject"
            value={step.content_template?.subject || ""}
            onChange={(e) =>
              onUpdate("content_template.subject", e.target.value)
            }
          />

          <Textarea
            placeholder="Message Content"
            value={step.content_template?.body || ""}
            onChange={(e) =>
              onUpdate("content_template.body", e.target.value)
            }
            className="min-h-[100px]"
          />

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Delay (hours)</Label>
              <Input
                type="number"
                min="0"
                placeholder="Delay hours"
                value={step.delay_hours}
                onChange={(e) =>
                  onUpdate("delay_hours", parseInt(e.target.value))
                }
              />
            </div>

            <div className="space-y-2">
              <Label>Channel</Label>
              <Select
                value={step.channel}
                onValueChange={(value) => onUpdate("channel", value)}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select Channel" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="email">Email</SelectItem>
                  <SelectItem value="sms">SMS</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};